import { maskQueryParamsOnRelativePath, maskQueryParamsOnUrl, } from '@thoughtspot/env-flags';
export const updatePropertiesWithOverrides = (properties) => {
    try {
        const propertiesUpdatedWithOverrides = {
            ...properties,
            $current_url: maskQueryParamsOnUrl(window.location.href),
            ...overrideIfExists(properties, 'navPath', maskQueryParamsOnRelativePath(String(properties.navPath))),
        };
        return propertiesUpdatedWithOverrides;
    }
    catch (e) {
        return properties;
    }
};
function overrideIfExists(properties, key, override) {
    return properties[key] ? { [key]: override } : {};
}
//# sourceMappingURL=event-property-overrides.js.map